import React from "react";
import "../../App.css";
import "./start.css";

const LoGo = () => (
  <div className="s-logo">
    <div className="box">
      <div className="wave -one" />
      <div className="wave -two" />
      <div className="wave -three" />
      <div className="title">Fadfada</div>
    </div>
  </div>
);

export default LoGo;
